import { ExistingUser } from "./components/existing-user";
import { NewUser } from "./components/new-user";

export const SiteActivationSwitcher = ({
    cohort
}: {
    cohort:
        | "new-user"
        | "existing-user"
        | "managed-user"
        | "week-one-user"
        | undefined;
}) => {
    switch (cohort) {
        case "new-user":
            return <NewUser />;
        //   case "week-one-user":
        //     return <ContactExpandSiteActivation/>;
        //   case "managed-user":
        //       return <GuardSiteActivation/>;
        default:
            return <ExistingUser />;
    }
};
